import { render, staticRenderFns } from "./dialog_tree.vue?vue&type=template&id=be441b44&scoped=true"
import script from "./dialog_tree.vue?vue&type=script&lang=js"
export * from "./dialog_tree.vue?vue&type=script&lang=js"
import style0 from "./dialog_tree.vue?vue&type=style&index=0&id=be441b44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be441b44",
  null
  
)

export default component.exports